
































import {Component, Vue} from "vue-property-decorator";
@Component({
  name: "AccountCooperationCompleted",
})
export default class AccountCooperationCompleted extends Vue {
  public isShow = false;
  public userId = "";

  public show(userId) {
    this.userId = userId;
    this.isShow = true;
  }
  public close() {
    this.isShow = false;
    this.$emit('refreshList');
  }
}
